// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Custom Properties for Law Enforcement Portal */

:root {
  /* Surfaces & Text */
  --dst-bg: #ffffff;
  --dst-surface: #ffffff;
  --dst-text: #1f2937;
  --dst-text-muted: #475569;
  --dst-muted: #606b85;
  --dst-border: #d7deed;
  --dst-card-bg: #fbfdff;
  --dst-card-border: #e7e7e7;
  --dst-panel-subtle: #f6f8ff;

  --dst-input-bg: #ffffff;
  --dst-input-border: #ccd7ef;
  --dst-input-disabled-bg: #eef2f9;

  /* Brand Colors */
  --dst-primary: #205ec8;
  --dst-primary-strong: #1741a8;
  --dst-primary-light: #dbeafe;

  --dst-success-bg: #ecfbf0;
  --dst-success-text: #0a6b2a;
  --dst-success-border: #b6ebc5;

  --dst-error-bg: #fff1f1;
  --dst-error-text: #8f1d1d;
  --dst-error-border: #f5c7c7;

  --dst-info-bg: #eef4ff;
  --dst-info-text: #1f4fa6;
  --dst-info-border: #c8d9ff;

  /* Table Styling */
  --dst-table-bg: var(--dst-surface);
  --dst-table-text: #222;
  --dst-table-head-bg: #e9f6ff;
  --dst-table-head-text: #1741a8;
  --dst-table-border: #e5e7eb;

  /* Status Totals */
  --dst-shift-total-bg: #e8f4ea;
  --dst-shift-total-text: #157b46;
  --dst-dept-total-bg: #e9fbe9;
  --dst-dept-total-text: #255b21;

  /* Portal Backgrounds */
  --dst-portal-main-bg: var(--dst-surface);
  --dst-tabs-bar-bg: var(--dst-surface);

  /* Layout & Spacing */
  --dst-radius-xl: 18px;
  --dst-radius-lg: 14px;
  --dst-radius-md: 10px;
  --dst-radius-sm: 6px;

  --dst-shadow-lg: 0 2px 22px rgba(0, 0, 0, 0.1);
  --dst-shadow-md: 0 4px 18px rgba(0, 0, 0, 0.09), 0 1.5px 3px rgba(0, 0, 0, 0.06);
  --dst-shadow-subtle: 0 1px 8px rgba(32, 94, 200, 0.03);

  --dst-space-1: 6px;
  --dst-space-2: 10px;
  --dst-space-3: 16px;
  --dst-space-4: 24px;
  --dst-space-5: 32px;

  /* Focus & Accessibility */
  --dst-focus: 2px solid #2563eb;
}

/* Dark Mode — explicit toggle (overrides OS preference) */
[data-theme="dark"] {
  --dst-bg: #0f172a;
  --dst-surface: #111827;
  --dst-text: #e5e7eb;
  --dst-text-muted: #c7d0de;
  --dst-muted: #9aa3b2;
  --dst-border: #2a3647;
  --dst-card-bg: #121d2c;
  --dst-card-border: #2a3647;
  --dst-panel-subtle: #172437;

  --dst-input-bg: #111a28;
  --dst-input-border: #34455e;
  --dst-input-disabled-bg: #1a2433;

  --dst-table-bg: #111a28;
  --dst-table-text: #e5e7eb;
  --dst-table-head-bg: #1a2740;
  --dst-table-head-text: #dbeafe;
  --dst-table-border: #243040;

  --dst-shift-total-bg: #0e2b1b;
  --dst-shift-total-text: #bcebc8;
  --dst-dept-total-bg: #11301a;
  --dst-dept-total-text: #b8f2b8;

  --dst-success-bg: #153322;
  --dst-success-text: #bcebc8;
  --dst-success-border: #2f5d45;

  --dst-error-bg: #3b1b1b;
  --dst-error-text: #ffb2b2;
  --dst-error-border: #7a3a3a;

  --dst-info-bg: #1a2d4a;
  --dst-info-text: #c6dcff;
  --dst-info-border: #35527f;

  --dst-portal-main-bg: var(--dst-surface);
  --dst-tabs-bar-bg: var(--dst-surface);
}

/* Light Mode — explicit override (for OS-dark users who chose light) */
[data-theme="light"] {
  --dst-bg: #ffffff;
  --dst-surface: #ffffff;
  --dst-text: #1f2937;
  --dst-text-muted: #475569;
  --dst-muted: #606b85;
  --dst-border: #d7deed;
  --dst-card-bg: #fbfdff;
  --dst-card-border: #e7e7e7;
  --dst-panel-subtle: #f6f8ff;

  --dst-input-bg: #ffffff;
  --dst-input-border: #ccd7ef;
  --dst-input-disabled-bg: #eef2f9;

  --dst-table-bg: #ffffff;
  --dst-table-text: #222;
  --dst-table-head-bg: #e9f6ff;
  --dst-table-head-text: #1741a8;
  --dst-table-border: #e5e7eb;

  --dst-shift-total-bg: #e8f4ea;
  --dst-shift-total-text: #157b46;
  --dst-dept-total-bg: #e9fbe9;
  --dst-dept-total-text: #255b21;

  --dst-success-bg: #ecfbf0;
  --dst-success-text: #0a6b2a;
  --dst-success-border: #b6ebc5;

  --dst-error-bg: #fff1f1;
  --dst-error-text: #8f1d1d;
  --dst-error-border: #f5c7c7;

  --dst-info-bg: #eef4ff;
  --dst-info-text: #1f4fa6;
  --dst-info-border: #c8d9ff;

  --dst-portal-main-bg: #ffffff;
  --dst-tabs-bar-bg: #ffffff;
}

/* Dark Mode — OS system preference */
@media (prefers-color-scheme: dark) {
  :root {
    --dst-bg: #0f172a;
    --dst-surface: #111827;
    --dst-text: #e5e7eb;
    --dst-text-muted: #c7d0de;
    --dst-muted: #9aa3b2;
    --dst-border: #2a3647;
    --dst-card-bg: #121d2c;
    --dst-card-border: #2a3647;
    --dst-panel-subtle: #172437;

    --dst-input-bg: #111a28;
    --dst-input-border: #34455e;
    --dst-input-disabled-bg: #1a2433;

    --dst-table-bg: #111a28;
    --dst-table-text: #e5e7eb;
    --dst-table-head-bg: #1a2740;
    --dst-table-head-text: #dbeafe;
    --dst-table-border: #243040;

    --dst-shift-total-bg: #0e2b1b;
    --dst-shift-total-text: #bcebc8;
    --dst-dept-total-bg: #11301a;
    --dst-dept-total-text: #b8f2b8;

    --dst-success-bg: #153322;
    --dst-success-text: #bcebc8;
    --dst-success-border: #2f5d45;

    --dst-error-bg: #3b1b1b;
    --dst-error-text: #ffb2b2;
    --dst-error-border: #7a3a3a;

    --dst-info-bg: #1a2d4a;
    --dst-info-text: #c6dcff;
    --dst-info-border: #35527f;

    --dst-portal-main-bg: var(--dst-surface);
    --dst-tabs-bar-bg: var(--dst-surface);
  }
}
`, "",{"version":3,"sources":["webpack://./assets/js/src/styles/variables.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;;EAE3B,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;;EAEhC,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;;EAE5B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;;EAE7B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;;EAE3B,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;;EAE1B,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;;EAE3B,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;;EAE9B,uBAAuB;EACvB,wCAAwC;EACxC,qCAAqC;;EAErC,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;;EAEpB,8CAA8C;EAC9C,gFAAgF;EAChF,sDAAsD;;EAEtD,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,0DAA0D;AAC1D;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;;EAE3B,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;;EAEhC,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;;EAE3B,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;;EAE9B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;;EAE7B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;;EAE3B,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;;EAE1B,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA,uEAAuE;AACvE;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;;EAE3B,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;;EAEhC,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;;EAE3B,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;;EAE9B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;;EAE7B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;;EAE3B,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;;EAE1B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE;IACE,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;;IAE3B,uBAAuB;IACvB,2BAA2B;IAC3B,gCAAgC;;IAEhC,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;;IAE3B,6BAA6B;IAC7B,+BAA+B;IAC/B,4BAA4B;IAC5B,8BAA8B;;IAE9B,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;;IAE7B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;;IAE3B,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;;IAE1B,wCAAwC;IACxC,qCAAqC;EACvC;AACF","sourcesContent":["/* CSS Custom Properties for Law Enforcement Portal */\n\n:root {\n  /* Surfaces & Text */\n  --dst-bg: #ffffff;\n  --dst-surface: #ffffff;\n  --dst-text: #1f2937;\n  --dst-text-muted: #475569;\n  --dst-muted: #606b85;\n  --dst-border: #d7deed;\n  --dst-card-bg: #fbfdff;\n  --dst-card-border: #e7e7e7;\n  --dst-panel-subtle: #f6f8ff;\n\n  --dst-input-bg: #ffffff;\n  --dst-input-border: #ccd7ef;\n  --dst-input-disabled-bg: #eef2f9;\n\n  /* Brand Colors */\n  --dst-primary: #205ec8;\n  --dst-primary-strong: #1741a8;\n  --dst-primary-light: #dbeafe;\n\n  --dst-success-bg: #ecfbf0;\n  --dst-success-text: #0a6b2a;\n  --dst-success-border: #b6ebc5;\n\n  --dst-error-bg: #fff1f1;\n  --dst-error-text: #8f1d1d;\n  --dst-error-border: #f5c7c7;\n\n  --dst-info-bg: #eef4ff;\n  --dst-info-text: #1f4fa6;\n  --dst-info-border: #c8d9ff;\n\n  /* Table Styling */\n  --dst-table-bg: var(--dst-surface);\n  --dst-table-text: #222;\n  --dst-table-head-bg: #e9f6ff;\n  --dst-table-head-text: #1741a8;\n  --dst-table-border: #e5e7eb;\n\n  /* Status Totals */\n  --dst-shift-total-bg: #e8f4ea;\n  --dst-shift-total-text: #157b46;\n  --dst-dept-total-bg: #e9fbe9;\n  --dst-dept-total-text: #255b21;\n\n  /* Portal Backgrounds */\n  --dst-portal-main-bg: var(--dst-surface);\n  --dst-tabs-bar-bg: var(--dst-surface);\n\n  /* Layout & Spacing */\n  --dst-radius-xl: 18px;\n  --dst-radius-lg: 14px;\n  --dst-radius-md: 10px;\n  --dst-radius-sm: 6px;\n\n  --dst-shadow-lg: 0 2px 22px rgba(0, 0, 0, 0.1);\n  --dst-shadow-md: 0 4px 18px rgba(0, 0, 0, 0.09), 0 1.5px 3px rgba(0, 0, 0, 0.06);\n  --dst-shadow-subtle: 0 1px 8px rgba(32, 94, 200, 0.03);\n\n  --dst-space-1: 6px;\n  --dst-space-2: 10px;\n  --dst-space-3: 16px;\n  --dst-space-4: 24px;\n  --dst-space-5: 32px;\n\n  /* Focus & Accessibility */\n  --dst-focus: 2px solid #2563eb;\n}\n\n/* Dark Mode — explicit toggle (overrides OS preference) */\n[data-theme=\"dark\"] {\n  --dst-bg: #0f172a;\n  --dst-surface: #111827;\n  --dst-text: #e5e7eb;\n  --dst-text-muted: #c7d0de;\n  --dst-muted: #9aa3b2;\n  --dst-border: #2a3647;\n  --dst-card-bg: #121d2c;\n  --dst-card-border: #2a3647;\n  --dst-panel-subtle: #172437;\n\n  --dst-input-bg: #111a28;\n  --dst-input-border: #34455e;\n  --dst-input-disabled-bg: #1a2433;\n\n  --dst-table-bg: #111a28;\n  --dst-table-text: #e5e7eb;\n  --dst-table-head-bg: #1a2740;\n  --dst-table-head-text: #dbeafe;\n  --dst-table-border: #243040;\n\n  --dst-shift-total-bg: #0e2b1b;\n  --dst-shift-total-text: #bcebc8;\n  --dst-dept-total-bg: #11301a;\n  --dst-dept-total-text: #b8f2b8;\n\n  --dst-success-bg: #153322;\n  --dst-success-text: #bcebc8;\n  --dst-success-border: #2f5d45;\n\n  --dst-error-bg: #3b1b1b;\n  --dst-error-text: #ffb2b2;\n  --dst-error-border: #7a3a3a;\n\n  --dst-info-bg: #1a2d4a;\n  --dst-info-text: #c6dcff;\n  --dst-info-border: #35527f;\n\n  --dst-portal-main-bg: var(--dst-surface);\n  --dst-tabs-bar-bg: var(--dst-surface);\n}\n\n/* Light Mode — explicit override (for OS-dark users who chose light) */\n[data-theme=\"light\"] {\n  --dst-bg: #ffffff;\n  --dst-surface: #ffffff;\n  --dst-text: #1f2937;\n  --dst-text-muted: #475569;\n  --dst-muted: #606b85;\n  --dst-border: #d7deed;\n  --dst-card-bg: #fbfdff;\n  --dst-card-border: #e7e7e7;\n  --dst-panel-subtle: #f6f8ff;\n\n  --dst-input-bg: #ffffff;\n  --dst-input-border: #ccd7ef;\n  --dst-input-disabled-bg: #eef2f9;\n\n  --dst-table-bg: #ffffff;\n  --dst-table-text: #222;\n  --dst-table-head-bg: #e9f6ff;\n  --dst-table-head-text: #1741a8;\n  --dst-table-border: #e5e7eb;\n\n  --dst-shift-total-bg: #e8f4ea;\n  --dst-shift-total-text: #157b46;\n  --dst-dept-total-bg: #e9fbe9;\n  --dst-dept-total-text: #255b21;\n\n  --dst-success-bg: #ecfbf0;\n  --dst-success-text: #0a6b2a;\n  --dst-success-border: #b6ebc5;\n\n  --dst-error-bg: #fff1f1;\n  --dst-error-text: #8f1d1d;\n  --dst-error-border: #f5c7c7;\n\n  --dst-info-bg: #eef4ff;\n  --dst-info-text: #1f4fa6;\n  --dst-info-border: #c8d9ff;\n\n  --dst-portal-main-bg: #ffffff;\n  --dst-tabs-bar-bg: #ffffff;\n}\n\n/* Dark Mode — OS system preference */\n@media (prefers-color-scheme: dark) {\n  :root {\n    --dst-bg: #0f172a;\n    --dst-surface: #111827;\n    --dst-text: #e5e7eb;\n    --dst-text-muted: #c7d0de;\n    --dst-muted: #9aa3b2;\n    --dst-border: #2a3647;\n    --dst-card-bg: #121d2c;\n    --dst-card-border: #2a3647;\n    --dst-panel-subtle: #172437;\n\n    --dst-input-bg: #111a28;\n    --dst-input-border: #34455e;\n    --dst-input-disabled-bg: #1a2433;\n\n    --dst-table-bg: #111a28;\n    --dst-table-text: #e5e7eb;\n    --dst-table-head-bg: #1a2740;\n    --dst-table-head-text: #dbeafe;\n    --dst-table-border: #243040;\n\n    --dst-shift-total-bg: #0e2b1b;\n    --dst-shift-total-text: #bcebc8;\n    --dst-dept-total-bg: #11301a;\n    --dst-dept-total-text: #b8f2b8;\n\n    --dst-success-bg: #153322;\n    --dst-success-text: #bcebc8;\n    --dst-success-border: #2f5d45;\n\n    --dst-error-bg: #3b1b1b;\n    --dst-error-text: #ffb2b2;\n    --dst-error-border: #7a3a3a;\n\n    --dst-info-bg: #1a2d4a;\n    --dst-info-text: #c6dcff;\n    --dst-info-border: #35527f;\n\n    --dst-portal-main-bg: var(--dst-surface);\n    --dst-tabs-bar-bg: var(--dst-surface);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
